module.exports = __webpack_public_path__ + "img/5.75a238a0.jpg";